module.exports = __webpack_public_path__ + "static/media/39c20c32-846f-4c73-a6ee-34885d67e3ce.a57eefbf.jpg";